<template>
  <div class="orderListWrapper">
    <!-- <mescroll-vue
      ref="mescroll"
      :down="down"
      @init="mescrollInit"
    > -->
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      style="height: calc(100vh - 140px);  overflow-y: scroll;"
    >
      <van-list
        v-model="page.loading"
        :error-text="page.errorText"
        :error.sync="page.error"
        :finished="page.finished"
        :finished-text="page.finishedText"
        :immediate-check="false"
        :offset="0"
        class="pad van-clearfix"
        @load="$emit('get-list', page.pageNum+=1)"
      >
        <div
          v-for="(item,index) in list"
          :key="'A'+item.orderNo"
          class="m-b-5"
          @click="$emit('to-order-detail',item)"
        >
          <van-cell
            :title-class="[ item.orderStatusRemark && item.orderStatusRemark.indexOf('取消') > -1 ? 'order-disabled full-width' : 'full-width']"
          >
            <template
              slot="title"
              class="full-width"
            >
              <!--往返订单部布局-->
              <!-- 机票  火车-->
              <!-- 11002 国内机票退票单
                     11003 国内机票改签单
                     11004 国际机票正常单
                     11005 国际机票退票单
                     11006 国际机票改签单
                     11009 火车票正常单
                     11010 火车票退票单
                     11011 火车票改签单
                     11023 11013 接送机订单
                 -->
              <div
                v-show="item.orderType==11002||item.orderType==11003||item.orderType==11004||item.orderType==11005||item.orderType==11006||item.orderType==11009||item.orderType==11010||item.orderType==11011||item.orderType==11023"
              >
                <van-row
                  align="center"
                  justify="space-between"
                  type="flex"
                >
                  <van-col span="17">
                    <div class="-inline-wrap">
                      <div class="-block-wrap">
                        <div class="-block">
                          <ld-icon
                            :type="item.orderType | icon"
                            class="block-order-icon main-color"
                            :class="{'aircraft-color':aircraftcolor(item),'car-color':coraftcolor(item)}"
                          />
                          <span class="font16 font-bold">
                            <span v-if="item.orderType == 11023"> {{ item.xcdd }}</span>
                            <span v-else> {{ item.voyageZh }}</span>
                          </span>
                          &nbsp;
                          <van-tag
                            v-if="item.orderType==11002 || item.orderType==11005 || item.orderType==11010 || item.orderType==11020"
                            class="-icon"
                            color="#ed6a0c"
                            plain
                          >
                            {{ $t('H117', '退') }}
                          </van-tag>
                          <van-tag
                            v-if="item.orderType==11003 || item.orderType==11006 || item.orderType==11011"
                            class="-icon"
                            color="#ff4949"
                            plain
                          >
                            改
                          </van-tag>
                          <van-tag
                            v-if="'' != item.productColor && null != item.productColor"
                            :color="item.productColor"
                          >
                            {{ item.productTag }}
                          </van-tag>
                          <van-tag
                            v-else
                            v-show="item.productType!=1&&item.productType!=6"
                            :color="item.productType | productTypeColor"
                            plain
                          >
                            {{ item.productType | productType }}
                          </van-tag>
                          <van-tag
                            v-show="item.isyw == 1"
                            plain
                            type="danger"
                          >
                            {{ $t('F620', '延误/取消') }}
                          </van-tag>
                        </div>
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    class="text-right"
                    span="7"
                  >
                    {{ item.orderStatusRemark }}
                    <van-tag
                      v-show="item.zjsl"
                      type="danger"
                    >
                      值
                    </van-tag>
                  </van-col>
                </van-row>
                <van-row>
                  <van-col
                    class="van-ellipsis"
                    span="17"
                  >
                    <!--                      {{ item.departTime }} | {{ item.flightNo }} | {{ item.cabinName }}-->
                    <span v-if="item.orderType==11003 || item.orderType==11006 || item.orderType==11011">
                      {{ item.nDepartTime }} | {{ item.nFlightNo }} | {{ item.nCabinName }}
                    </span>
                    <span v-else>{{ item.departTime }} | {{ item.flightNo }} | {{ item.cabinName }}</span>
                  </van-col>
                  <van-col
                    :class="[item.orderStatus == 7 ? 'text-right' : 'red text-right']"
                    span="7"
                    v-if="item.orderType!=11005"
                  >
                    <span class="font12">&yen; </span>
                    <big v-if="item.subtotal == '待确定'">
                      {{ item.subtotal }}
                    </big>
                    <big v-else>
                      {{
                        (((item.subtotal - 0) ? (item.subtotal - 0) : item.subtotal) +
                          ((item.subtotal - 0) ? (item.bxPrice || 0) : ''))|fixed(1)
                      }}
                    </big>
                  </van-col>
                  <van-col
                    :class="[item.orderStatus == 7 ? 'text-right' : 'red text-right']"
                    span="7"
                    v-if="item.orderType==11005"
                  >
                    <span class="font12">&yen; </span>
                    <!-- <big v-if="item.subtotal == '待确定'">
                        {{ item.subtotal }}
                      </big>
                      <big v-else>
                        {{
                          (((item.subtotal - 0) ? (item.subtotal - 0) : item.subtotal) +
                            ((item.subtotal - 0) ? (item.bxPrice || 0) : ''))|fixed(1)
                        }}
                      </big> -->
                    <big>{{ item.cuRefundPoundage==-1 ? '待核算' : item.cuRefundPoundage }}</big>
                  </van-col>
                </van-row>
              </div>
              <!-- 机票  火车-->
              <!--联程订单布局-->
              <!-- 11001 国内机票正常单 -->
              <div v-show="item.orderType==11001">
                <div
                  v-if="item.voyageType==1"
                  class="Multi-reach"
                >
                  <div
                    style="width: 500px"
                  >
                    <div class="gobeyond" >
                      <ld-icon
                        :type="item.orderType | icon"
                        class="block-order-icon main-color"
                        style="margin: 0px 10px 0px 0px;"
                      />
                      <span>{{ item.voyageZh }}</span>
                    </div>
                    <span v-if="item.orderType==11003 || item.orderType==11006 || item.orderType==11011">
                      {{ item.nDepartTime }} | {{ item.nFlightNo }} | {{ item.nCabinName }}
                    </span>
                    <span v-else>{{ item.departTime }} | {{ item.flightNo }} | {{ item.cabinName }}</span>
                  </div>
                  <div>
                    <!--                      类型-->
                    <van-col
                      class="text-right "
                      span="7"
                      style="display: contents;white-space: nowrap;"
                    >
                      <span style="white-space: nowrap">{{ item.orderStatusRemark }}</span>
                      <van-tag
                        v-show="item.zjsl"
                        type="danger"
                      >
                        值
                      </van-tag>
                    </van-col>
                    <!-- <br> -->
                    <!--                      价格-->
                    <van-col
                      :class="[item.orderStatus == 7 ? 'text-right' : 'red text-right',hisparty(item) ? 'marg_left' :'']"
                      span="7"
                      style="display: flex;"
                      class="flex_cont"
                    >
                      <span class="font12">&yen; </span>
                      <big v-if="item.subtotal == '待确定'">
                        {{ item.subtotal }}
                      </big>
                      <big v-else>
                        {{
                          (((item.subtotal - 0) ? (item.subtotal - 0) : item.subtotal) +
                            ((item.subtotal - 0) ? (item.bxPrice || 0) : ''))|fixed(1)
                        }}
                      </big>
                    </van-col>
                  </div>
                </div>
                <div
                  v-else-if="item.voyageType==3"
                  class="Multi-reach"
                >
                  <div
                    style="width: 500px"
                  >
                    <div
                      v-for="(Multireach,index) in item.orderRangeBeanList "
                      :key="index"
                      class="gobeyond"
                    >
                      <ld-icon
                        :type="item.orderType | icon"
                        class="block-order-icon main-color"
                        style="margin: 0px 10px 0px 0px;"
                      />
                      <span>{{ Multireach.voyageZh }}</span>
                      <van-tag class="tag-green">
                        <!--                          <span class="font10">第{{ Multireach.sn }}程</span>-->
                      </van-tag>
                      <br>
                      <span>{{ Multireach.departTime }} | {{ Multireach.flightNo }} | {{
                        Multireach.cabinName
                      }}</span>
                    </div>
                  </div>
                  <div>
                    <!--                      类型-->
                    <van-col
                      class="text-right"
                      span="7"
                      style="display: contents; white-space: nowrap;"
                    >
                      {{ item.orderStatusRemark }}
                      <van-tag
                        v-show="item.zjsl"
                        type="danger"
                      >
                        值
                      </van-tag>
                    </van-col>
                    <!-- <br> -->
                    <!--                      价格-->
                    <van-col
                      :class="[item.orderStatus == 7 ? 'text-right' : 'red text-right']"
                      span="7"
                      style="display: flex;"
                      class="flex_cont"
                    >
                      <span class="font12">&yen; </span>
                      <big v-if="item.subtotal == '待确定'">
                        {{ item.subtotal }}
                      </big>
                      <big v-else>
                        {{
                          (((item.subtotal - 0) ? (item.subtotal - 0) : item.subtotal) +
                            ((item.subtotal - 0) ? (item.bxPrice || 0) : ''))|fixed(1)
                        }}
                      </big>
                    </van-col>
                  </div>
                </div>
                <div
                  v-else-if="item.voyageType==2"
                  class="Multi-reach"
                >
                  <div
                    style="width: 500px"
                  >
                    <div
                      v-for="(Multireach,index) in item.orderRangeBeanList "
                      :key="index"
                      class="gobeyond"
                    >
                      <ld-icon
                        :type="item.orderType | icon"
                        class="block-order-icon main-color"
                        style="margin: 0px 10px 0px 0px;"
                      />
                      <span>{{ Multireach.voyageZh }}</span>
                      <van-tag class="tag-green">
                        <!--                          <span class="font10">第{{ Multireach.sn }}程</span>-->
                      </van-tag>
                      <br>
                      <span>{{ Multireach.departTime }} | {{ Multireach.flightNo }} | {{
                        Multireach.cabinName
                      }}</span>
                    </div>
                  </div>
                  <div>
                    <!--                      类型-->
                    <van-col
                      class="text-right"
                      span="7"
                      style="display: contents; white-space: nowrap;"
                    >
                      {{ item.orderStatusRemark }}
                      <van-tag
                        v-show="item.zjsl"
                        type="danger"
                      >
                        值
                      </van-tag>
                    </van-col>
                    <!-- <br> -->
                    <!--                      价格-->
                    <van-col
                      :class="[item.orderStatus == 7 ? 'text-right' : 'red text-right']"
                      span="7"
                      style="display: flex;"
                      class="flex_cont"
                    >
                      <span class="font12">&yen; </span>
                      <big v-if="item.subtotal == '待确定'">
                        {{ item.subtotal }}
                      </big>
                      <big v-else>
                        {{
                          (((item.subtotal - 0) ? (item.subtotal - 0) : item.subtotal) +
                            ((item.subtotal - 0) ? (item.bxPrice || 0) : ''))|fixed(1)
                        }}
                      </big>
                    </van-col>
                  </div>
                </div>
              </div>
              <!-- 酒店 -->
              <!--
                11007  酒店正常单
                  11008   酒店退单
                 -->
              <div v-if="item.orderType==11007||item.orderType==11008">
                <van-row
                  align="center"
                  justify="space-between"
                  type="flex"
                >
                  <van-col span="18">
                    <div class="-inline-wrap">
                      <div class="-block-wrap">
                        <div class="-block">
                          <ld-icon
                            :type="item.orderType|icon"
                            class="block-order-icon main-color"
                            :class="{'hotel-color':item.orderStatusRemark!=='已取消'}"
                          />
                          <span class="font16 font-bold">
                            <span> {{ item.voyageZh }}</span>
                          </span>
                          &nbsp;
                          <van-tag
                            v-if="item.orderType==11008"
                            class="-icon"
                            color="#ed6a0c"
                            plain
                          >
                            {{ $t('H117', '退') }}
                          </van-tag>
                        </div>
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    class="text-right"
                    span="6"
                  >
                    {{ item.orderStatusRemark }}
                  </van-col>
                </van-row>
                <van-row>
                  <van-col
                    class="van-ellipsis"
                    span="17"
                  >
                    <div>
                      {{ item.departTime.substring(5, item.departTime.length) }}
                      {{ $t('H041', '至') }}
                      {{ item.nDepartTime.substring(5, item.nDepartTime.length) }} | {{ item.nights }}
                      {{ $t('H008', '晚') }}
                      <span v-if="item.productImage == 2">
                        | {{
                          item.voyageType == '1' ? (item.productType == '1' ? '到店付-担保' : '到店付') : $t('H030', '预付')
                        }}
                      </span>
                      <span
                        v-if="item.sfpf == 1"
                        class="label-red__solid"
                      >
                        拼
                      </span>
                    </div>
                    {{ item.flightNo }} | {{ item.rooms }} {{ $t('E205', '间') }}
                  </van-col>
                  <van-col
                    class="red text-right"
                    span="7"
                  >
                    <span class="font12">&yen; </span><big> {{ item.subtotal }}</big>
                  </van-col>
                </van-row>
              </div>
              <!-- 酒店 -->

              <!-- 用车 -->
              <div v-show="item.orderType==11018">
                <van-row
                  align="center"
                  justify="space-between"
                  type="flex"
                >
                  <van-col span="18">
                    <div class="-inline-wrap">
                      <div class="-block-wrap">
                        <div class="-block">
                          <ld-icon
                            :type="item.orderType|icon"
                            class="block-order-icon main-color"
                            :class="{'car-color':item.orderStatusRemark!=='已取消'}"
                          />
                          <span class="font16 font-bold">
                            {{ item.voyageZh }}<span v-show="item.productType">-{{
                              item.productType|carproductType
                            }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    class="text-right"
                    span="6"
                  >
                    {{ item.orderStatusRemark }}
                  </van-col>
                </van-row>
                <van-row>
                  <van-col
                    class="van-ellipsis"
                    span="17"
                  >
                    {{ item.departTime }} | {{ item.cabinName }}
                  </van-col>
                  <van-col
                    class="red text-right"
                    span="7"
                  >
                    <span class="font12">&yen; </span><big> {{ item.subtotal }}</big>
                  </van-col>
                </van-row>
                <van-row
                  align="center"
                  type="flex"
                >
                  <van-col span="2">
                    <div>
                      <ld-icon
                        class="block-order-icon main-color"
                        color="#3196fb"
                        type="iconweibiaoti-17"
                      />
                    </div>
                  </van-col>
                  <van-col span="17">
                    <div>{{ item.scdd ? (item.scdd.split('|')[0]) : '' }}</div>
                  </van-col>
                </van-row>
                <van-row
                  v-slot:default
                  align="center"
                  type="flex"
                >
                  <van-col span="2">
                    <div>
                      <ld-icon
                        class="block-order-icon main-color"
                        color="#ff923e"
                        type="iconweibiaoti-18"
                      />
                    </div>
                  </van-col>
                  <van-col span="17">
                    <div>{{ item.xcdd ? (item.xcdd.split('|')[0]) : '' }}</div>
                  </van-col>
                </van-row>
              </div>
              <!-- 用车 -->

              <!-- 机场服务 -->
              <!--
                  11028   休息室
                  11029   快速安检 
                  11030    优选值机 
                  11031    要客通
                 -->
              <div v-if="item.orderType==11028||item.orderType==11029||item.orderType==11030||item.orderType==11031">
                <van-row
                  align="center"
                  justify="space-between"
                  type="flex"
                >
                  <van-col span="18">
                    <div class="-inline-wrap">
                      <div class="-block-wrap">
                        <div class="-block">
                          <ld-icon
                            :type="item.orderType|icon"
                            class="block-order-icon main-color"
                          />
                          <span
                            class="font16 font-bold"
                          >
                            {{ item.orderType|orderType }} - {{ item.voyageZh }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    class="text-right"
                    span="6"
                  >
                    {{ item.orderStatusRemark }}
                  </van-col>
                </van-row>
                <van-row>
                  <van-col
                    class="van-ellipsis"
                    span="17"
                  >
                    <div v-show="item.orderType==11028">
                      {{ item.cabinName }} | {{ item.personNum }}人次
                    </div>
                    <div v-show="item.orderType==11029">
                      {{ item.nCabinName|setOutModel }} | {{ item.nFlightNo }}航站楼 | {{ item.personNum }}人次
                    </div>
                    <div v-show="item.orderType==11030">
                      {{ item.departTime }} | {{ item.flightNo }} | {{ item.personNum }}人次
                    </div>
                    <div v-show="item.orderType==11031">
                      {{ item.departTime }} | {{ item.flightNo }} | {{ item.personNum }}人次
                    </div>
                  </van-col>
                  <van-col
                    class="red text-right"
                    span="7"
                  >
                    <span class="font12">&yen; </span><big> {{ item.subtotal || 0 }}</big>
                  </van-col>
                </van-row>
              </div>
              <!-- 机场服务 -->
              <div>
                <span class="line-clamp">
                  <van-tag
                    v-if="item.tripType == 2"
                    color="#5E68A0"
                    plain
                  >
                    私
                  </van-tag> {{ item.psgName }}
                </span>
              </div>
            </template>
            <!--  -->
            <template slot="label">
              <!-- <div class="p-b-5 van-ellipsis">
                {{ item.cabinName }}
              </div> -->
              <van-row
                class="text-right"
                gutter="8"
                justify="end"
                type="flex"
              >
                <van-col
                  span="6"
                  v-if="item.isShowEndorse==1 && ((item.orderType==11009 && trainchangeshow) || ((item.orderType==11001 || item.orderType==11004) && changeshow))"
                >
                  <ld-button
                    defaults
                    size="sm"
                    style="width: 70px;"
                    @click.stop="$emit('to-order-detail',item,'applyChange')"
                  >
                    {{ $t('B034', '改签') }}
                  </ld-button>
                </van-col>
                <van-col
                  v-if="item.isShowCancel==1 || item.isShowCancelChange == 1 || item.isShowCancelRefund == 1"
                  span="6"
                >
                  <ld-button
                    defaults
                    size="sm"
                    style="width: 70px;"
                    @click.stop="$emit('cancel',item)"
                  >
                    {{ $t('B008', '取消') }}
                  </ld-button>
                </van-col>
                <van-col
                  v-if="item.isShowCancelApproval == 1 && item.orderStatusRemark!='已订座|审批中'"
                  span="7"
                >
                  <ld-button
                    defaults
                    size="sm"
                    style="width: 70px;"
                    @click.stop="$emit('revert-approval',item)"
                  >
                    {{ $t('B065', '撤回') }}
                  </ld-button>
                </van-col>
                <van-col
                  v-if="item.isShowApproval==1"
                  span="6"
                >
                  <ld-button
                    main
                    size="sm"
                    style="width: 70px;"
                    @click.stop="$emit('send-approval', item)"
                  >
                    {{ $t('B028', '送审') }}
                  </ld-button>
                </van-col>
                <van-col
                  v-if="item.isShowPay==1"
                  span="6"
                >
                  <ld-button
                    main
                    size="sm"
                    style="width: 70px;"
                    @click.native.stop="$emit('pay', item)"
                  >
                    {{ $t('B014', '支付') }}
                  </ld-button>
                </van-col>
                <van-col
                  v-if="item.isShowRefund==1 && ((item.orderType==11009 && trainrefundshow) || ((item.orderType==11001 || item.orderType==11004) && refundshow))"
                  span="6"
                >
                  <ld-button
                    defaults
                    size="sm"
                    style="width: 70px;"
                    @click.stop="$emit('to-order-detail', item, 'applyRefund')"
                  >
                    {{ orderType[item.orderType] ? orderType[item.orderType] : $t('B035', '退票') }}
                  </ld-button>
                </van-col>
              </van-row>
            </template>
            <!--  -->
          </van-cell>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- </mescroll-vue> -->
  </div>
</template>
<script>
import {List, Cell, Tag, Image, PullRefresh} from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldButton from 'Common/ldButton'
import {mapGetters} from 'vuex'
import mixin from './orderMixin'
import {getParameter} from 'Utils/publicApi'
import {formatDate} from 'Utils/dateUtil'

export default {
  name: 'OrderList',
  mixins: [mixin],
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [PullRefresh.name]: PullRefresh,
    ldButton,
    MescrollVue
  },
  data() {
    return {
      showFirstProductTypeText: '',
      showFirstProductTypeColor: '',
      mescroll: '',
      orderType: {
        11007: '退房'
      },
      down: {use: false},
      isLoading: false,
      refundshow:true,
      changeshow:true,
      trainrefundshow:true,
      trainchangeshow:true,
    }
  },
  props: {
    page: {
      type: Object,
      default: function () {
        return {}
      }
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    ...mapGetters({
      orderListParams: 'orderListParams',
      userInfo: 'userInfo'
    }),
  },
  beforeDestroy() {
    // this.$store.commit('SET_ORDERLISTPARAMS', {scrollTop: this.mescroll.getScrollTop()})
  },
  async	created() {
    this.$api['common/queryVipParameter']({
      paramNo: '11601024'
    }).then(resp => {
      let cacheProduct = resp.data || {}
      this.showFirstProductTypeText = cacheProduct.value2
      this.showFirstProductTypeColor = cacheProduct.value1
    })
    // 隐藏机票的退改
    let data1= await  getParameter('10917')
    let data2= await  getParameter('10916')
    // 隐藏火车票的退改
    let data3= await  getParameter('10920')
    let data4= await  getParameter('10921')


    data1.value1== '1'? this.refundshow=false:this.refundshow=true
    data2.value1== '1'? this.changeshow=false:this.changeshow=true
    data3.value1== '1'? this.trainrefundshow=false:this.trainrefundshow=true
    data4.value1== '1'? this.trainchangeshow=false:this.trainchangeshow=true

    let subsequent={
      refundshow:this.refundshow,
      changeshow:this.changeshow,
      trainrefundshow:this.trainrefundshow,
      trainchangeshow:this.trainchangeshow,
    }

    this.$store.commit('tr/subsequent',subsequent)
  },
  methods: {
    formatDate,
    onRefresh() {
      this.$emit('get-list', (this.page.pageNum = 1))
      this.isLoading = false
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll
      setTimeout(function () {
        this.mescroll.scrollTo(this.orderListParams.scrollTop || 0)
      }.bind(this), 400)
    },
    hisparty(item){
      if(item.orderStatusRemark){
        if(item.orderStatusRemark.length > 5){
          return true
        }else{
          return  false
        }
      }
     
     
    },
    aircraftcolor(item){//火车
      if(item.orderStatusRemark!=='已取消'){
        if(item.orderType=='11009' || item.orderType=='11010' || item.orderType=='11011'){
          return true
        }
      }
      return false
    },
    coraftcolor(item){//用车订单
      if(item.orderStatusRemark!=='已取消'){
        if(item.orderType=='11013'){ //接送机的订单
          return true
        }
      }
      return false
    }
  }
}
</script>
<style lang="less" scoped>
@import '~Assets/styles/currency/ht.less';

.pad {
  padding: 5px 8px;
}

.p-b-5 {
  padding-bottom: 5px;
}

.m-b-5 {
  margin-bottom: 5px;
}

.m-r-5 {
  margin-right: 5px;
}

.orderListWrapper {
  height: calc(100vh - 140px);
  overflow: hidden;
}

.icon {
  margin-right: 5px;
  min-width: 1em;
  height: 24px;
  font-size: 16px;
}

.van-tag {
  vertical-align: text-bottom;
}

.line-clamp {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.-inline-wrap {
  display: inline-block;
  max-width: 100%;
}

.-block-wrap {
  width: 100%;
}

.-block {
  position: relative;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 20px;
}

.-icon {
  position: absolute;
  width: 20px;
  right: 0;
  top: 2px;
}

.block-order-icon {
  font-size: 22px;
  vertical-align: bottom;
}

//多程布局
.Multi-reach {
  display: flex;
  align-items: center;
}

.tag-green {
  background-image: linear-gradient(-90deg, #45bf9b 0%, #52dcb3 100%), linear-gradient(#eef2f7, #eef2f7);
  background-blend-mode: normal, normal;
  box-shadow: 0px 2px 2px 0px rgba(51, 164, 131, 0.3);
  border-radius: 5px;
  margin: 0 3px 0px 0px;
  margin: 0px 0px 0px 20px;
}

.gobeyond {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width:264px
}
// .go_wid264{
// //  width: 264px;
// }
// .go_wid244{
//   // width: 244px;
// }
.marg_left{
  width: 100%;
    display: flex;
    justify-content: end;
}
.aircraft-color{//火车票
  color: #EC808D !important;
}
.car-color{//用车
  color: #70B603 !important;
}
.hotel-color{//酒店
  color: #BFBF00 !important;
}
// .align_item{
//     display: flex;
//     flex-direction: column;
//     align-items: center;
// }
.flex_cont{
    display: flex;
    width: 100%;
    /* text-align: center; */
    align-items: center;
    justify-content: center;
}
</style>
